import {
    ClientRelationshipGroupInformation,
    clientRelationshipGroupInformationWithEmptyValues
} from "../models/ClientRelationshipGroupHierarchy";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store/store";

export type ClientRelationshipGroupInfoState = {
    clientRelationshipGroupInfoState: ClientRelationshipGroupInformation,
};

export const initialClientRelationshipGroupInfoState: ClientRelationshipGroupInfoState = {
    clientRelationshipGroupInfoState: clientRelationshipGroupInformationWithEmptyValues
}

const clientRelationshipGroupInfoStateSlice = createSlice({
    name: "clientRelationshipGroupInfo",
    initialState: initialClientRelationshipGroupInfoState,
    reducers: {
        setClientRelationshipGroupInfoState: (state, action: PayloadAction<ClientRelationshipGroupInformation>) => {
            state.clientRelationshipGroupInfoState = action.payload;
        }
    }
});

export const {
    setClientRelationshipGroupInfoState
} = clientRelationshipGroupInfoStateSlice.actions;

export const getClientRelationshipGroupInfoState = (state: RootState) => state.client.clientRelationshipGroupInfo.clientRelationshipGroupInfoState;

export default clientRelationshipGroupInfoStateSlice.reducer;